export default __webpack_public_path__ + "static/media/problema-03.edb1d0a5.webp";